function toggleNavbar() {
    var $navbarCollapse = $('.navbar-collapse');
    $(".navbar-toggler").click(function () {
        $('header').toggleClass("show-menu");
        if ($navbarCollapse.hasClass("show")) {
            $navbarCollapse.collapse('hide');
        } else {
            $navbarCollapse.collapse('show');
        }
    });
}

$(document).ready(function() {
    toggleNavbar();
});